export default __webpack_public_path__ + "static/media/india.d5494e47.jpg";